import { useDispatch, useSelector } from 'react-redux'
import { clearSelectedSetup, selectSetupName } from '../../../features/system/systemSlice'
import { useMasterData } from '../../../hooks/api/useMasterData'
import { setSetup } from '../../../features/setup/setupSlice'
import SetupTHead from '../theads/SetupTHead'
import { setUpTemperature } from '../../../data/admin-data'
import SetupTemperatureTBody from '../tbody/SetupTemperatureTBody'
import SetupHeader from '../headers/SetupHeader'

export default function SetupTemperature() {

    const dispatch = useDispatch()
    const selectedSetupName = useSelector(selectSetupName)
    const { productTemperature, isLoadingProductTemperature, isErrorProductTemperature, errorMessageProductTemperature, } = useMasterData()

    return (
        <>
            <SetupHeader
                onClick={() => dispatch(clearSelectedSetup())}
                handleClickNew={() => dispatch(setSetup({ type: 'show', value: 'setUpTemperature'}))}
                selectedSetupName={selectedSetupName}
            />
            <div className='h-full overflow-hidden bg-white rounded border'>
                <div className='overflow-y-auto h-full'>
                    <table className='min-w-max w-full'>
                        <SetupTHead data={setUpTemperature}/> 
                        <SetupTemperatureTBody
                            data={productTemperature}
                            isLoading={isLoadingProductTemperature}
                            isError={isErrorProductTemperature}
                            errorMessage={errorMessageProductTemperature}
                            isEmpty={productTemperature.length === 0}
                        />
                    </table>
                </div>
            </div>
        </>
    )
}
